import axioPath from 'api/axioPath';
import ptPlusApiBaseUrl from '../../../api/ptPlusApiBaseUrl';
import { showAppLoader, hideAppLoader } from '../app';


export const ptPlusBuyBackMainLocationList = () => (dispatch) => {
  const token = localStorage.getItem("token")

  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.get(`ptms/buyback/mainlocation_list`, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const ptPlusBuyBackSubLocationList = (data) => (dispatch) => {
  const token = localStorage.getItem("token")

  // dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/buyback/location_list/byids`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      // dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      // dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const ptPlusBuyBackVendorList = () => (dispatch) => {
  const token = localStorage.getItem("token")
  dispatch(showAppLoader());
  return axioPath
    .get(`user/v2/buyback_vendorlist`, {
      headers: {
        Authorization: token,
        UserType: 'internal'
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const ptPlusBuyBackSaveData = (postData) => (dispatch) => {
  const token = localStorage.getItem("token")

  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/buyback/create`, postData, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const ptPlusBuyBackListing = (data) => (dispatch) => {
  const token = localStorage.getItem("token")

  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/buyback/list`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const ptPlusBuyBackCreateUpdateData = (postData) => (dispatch) => {
  const token = localStorage.getItem("token")

  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/buyback/update`, postData, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const ptPlusBuyBackVendorFeeItemDelete = (data) => (dispatch) => {
  const token = localStorage.getItem("token");

  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.delete(`ptms/buyback/delete`, {
    data,
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
